import React from 'react'

import { datatableTypes } from '@/typings'
import { useDispatch } from 'react-redux'
import { datatableActions } from '@/react-components/datatable/store'
import DatatableFulltextFilter from './DatatableFulltextFilter'
import DatatableDatepickerFilter from './DatatableDatepickerFilter'
import DatatableSelectFilter from './DatatableSelectFilter'

type Props = {
	filter: datatableTypes.DatatableFilter
	col: string
	label: string
}

const DatatableFilter = ({ filter, col, label }: Props) => {
	const dispatch = useDispatch()

	const handleChange = (value: any) => {
		dispatch(datatableActions.updateFilter({ filter, col, value }))
		dispatch(datatableActions.getData({ purge: true }))
	}

	return (
		<div className="p-4">
			<div className="font-bold mb-2 lg:hidden">{label}</div>
			{filter.type === 'select' && <DatatableSelectFilter dataKey={filter.dataKey} onChange={handleChange} />}
			{filter.type === 'multiselect' && (
				<DatatableSelectFilter dataKey={filter.dataKey} onChange={handleChange} multiple />
			)}
			{filter.type === 'fulltext' && <DatatableFulltextFilter dataKey={filter.dataKey} onChange={handleChange} />}
			{filter.type === 'datepicker' && <DatatableDatepickerFilter dataKey={filter.dataKey} onChange={handleChange} />}
		</div>
	)
}

export default DatatableFilter
